import { cn } from "@/lib/utils";

/** Text fields, selects, textareas — matches account invitation-style controls */
export const adminControlClass =
  "bg-sand w-full rounded-[10px] border border-line-strong px-3 py-2.5 text-[16px] leading-snug text-ink outline-none transition-shadow focus:border-ink/25 focus:shadow-[0_0_0_2px_rgba(42,22,69,0.1)]";

export const adminLabelClass = "mb-1 block text-sm font-medium text-ink/90";

export function adminStatusBadgeClass(active: boolean) {
  return cn(
    "cursor-pointer rounded-lg px-2 py-1 text-xs font-medium",
    active ? "bg-green/12 text-green" : "bg-danger/10 text-danger",
  );
}
